import styled from "@emotion/styled";
import theme from "@theme";
import overlay from "@assets/images/overlay.png";
import { Link as RouterLink } from "react-router-dom";
import InnoIcons from "InnoUI/innoicons";
import { Select } from "antd";

const Container = styled.div`
  background: linear-gradient(135deg, #fef4e9 0%, #ffe4b3 100%);
  min-height: 100vh;
  width: 100%;
  
  .MuiTabs-indicator {
    background-color: ${theme.colors.themeColor};
  }
`;

const Banner = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  background-color: ${theme.colors.peach};
  height: 210px;
  padding: 0px 70px;
  text-align: center;
`;

const LineImage = styled.img`
  height: 150px;
  width: 200px;
`;
const Greeting = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;
const GreetingTextDiv = styled.div`
  display: flex;
  align-items: center;
`;
const GreetingText = styled.p`
  margin-block: 0px;
  padding-block: 0px;
  font-size: 30px;
  color: ${theme.colors.sienna};
  font-weight: bold;
  margin-left: 200px;
`;
const HandImage = styled.img`
  height: 45px;
  width: 45px;
`;
const FormattedDate = styled.p`
  margin-block: 0px;
  padding-block: 0px;
  font-size: 20px;
  margin-left: 200px;
`;
const WorkImage = styled.img`
  height: 210px;
  width: 350px;
`;
const CircleImage = styled.img`
  height: 200px;
  width: 200px;
  margin-bottom: 190px;
  margin-right: -145px;
`;
const TabDiv = styled.div`
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-radius: 1.25rem;
  padding: 1.5rem 2rem;
  display: flex;
  gap: 1.5rem;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  margin: 0;
  
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
    padding: 1rem 1.5rem;
    border-radius: 1rem;
  }
  
  @media (max-width: 480px) {
    padding: 0.75rem 1rem;
    gap: 0.75rem;
    border-radius: 0.75rem;
  }
`;

const Input = styled.input`
  height: 30px;
  width: 50%;
  border: 2px solid #f0f0f0;
  border-radius: 5px;
  padding-right: 30px;
  padding: 8px;
  &::placeholder {
    color: #afafaf;
    opacity: 1;
  }
`;

const CardDiv = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 2rem;
  padding: 2rem 1rem;
  max-width: none;
  margin: 0;
  
  @media (max-width: 768px) {
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 1.5rem;
    padding: 1.5rem 0.75rem;
  }
  
  @media (max-width: 480px) {
    grid-template-columns: 1fr;
    gap: 1rem;
    padding: 1rem 0.5rem;
  }
`;

const ViewText = styled.p`
  margin: 0;
  font-size: 0.875rem;
  font-weight: normal;

  margin-top: 7px;

  @media (max-width: 850px) {
    display: none;
  }
`;
const SecondWrapper = styled.div`
  display: flex;
  margin-left: 20px;
  margin-right: 20px;
  gap: 20px;
  @media (max-width: 850px) {
    gap: 20px;
  }
  @media (max-width: 600px) {
    gap: 20px;
    margin-left: 10px;
  }
`;
const Heading = styled.span`
  @media (max-width: 650px) {
    font-size: 15px;
    vertical-align: baseline;
  }
`;
const Link = styled(RouterLink)`
  display: flex;
  align-items: center;
  text-decoration: none;
  color: inherit;
`;

const LinkWrapper = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
`;
const SecondWrapperChild = styled.div`
  display: flex;
  cursor: pointer;
`;
// Make sure to import your overlay image

const Noproject = styled.div`
  background-image: url(${overlay});
  width: 100%;
  background-size: cover;
  height: 90vh;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

const InputContiner = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  width: 400px;
  
  @media (max-width: 768px) {
    width: 100%;
  }
`;

const SearchIcon = styled(InnoIcons.SearchIcon)`
  position: absolute;
  left: 12px;
  color: ${theme.colors.modernGray[400]};
  font-size: 18px;
  z-index: 1;
`;

const InputStyle = styled.input`
  width: 100%;
  height: 44px;
  padding: 12px 12px 12px 40px;
  font-size: 14px;
  border: 1px solid rgba(227, 110, 0, 0.2);
  border-radius: 0.75rem;
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(10px);
  transition: all 0.3s ease;

  &:focus {
    outline: none;
    border-color: ${theme.colors.modernPrimary};
    box-shadow: 0 0 0 3px rgba(227, 110, 0, 0.1);
  }

  &::placeholder {
    color: ${theme.colors.modernGray[400]};
  }

  @media (max-width: 768px) {
    font-size: 13px;
    height: 40px;
    padding: 10px 10px 10px 36px;
  }
  
  @media (max-width: 480px) {
    font-size: 12px;
    height: 36px;
    padding: 8px 8px 8px 32px;
  }
`;

const ResponsiveContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

const StyledSelect = styled(Select)`
  width: 200px;
  height: 44px;
  margin-left: 0;

  .ant-select-selector {
    background: rgba(255, 255, 255, 0.9) !important;
    backdrop-filter: blur(10px) !important;
    border: 1px solid rgba(227, 110, 0, 0.2) !important;
    border-radius: 0.75rem !important;
    transition: all 0.3s ease !important;
    height: 44px !important;
    display: flex !important;
    align-items: center !important;
  }

  .ant-select-focused .ant-select-selector {
    border-color: ${theme.colors.modernPrimary} !important;
    box-shadow: 0 0 0 3px rgba(227, 110, 0, 0.1) !important;
  }

  .ant-select-selection-item {
    line-height: 44px !important;
    height: 44px !important;
    display: flex !important;
    align-items: center !important;
  }

  @media (max-width: 768px) {
    width: 100%;
    height: 40px;
    
    .ant-select-selector {
      height: 40px !important;
    }
    
    .ant-select-selection-item {
      line-height: 40px !important;
      height: 40px !important;
    }
  }
  
  @media (max-width: 480px) {
    height: 36px;
    
    .ant-select-selector {
      height: 36px !important;
    }
    
    .ant-select-selection-item {
      line-height: 36px !important;
      height: 36px !important;
    }
  }
`;

const ControlsWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-direction: row;
  align-items: center;
  gap: 1rem;
  flex: 1;

  @media (max-width: 768px) {
    justify-content: flex-start;
    width: 100%;
    flex-wrap: wrap;
    gap: 0.75rem;
  }
  
  @media (max-width: 480px) {
    gap: 0.5rem;
  }
`;

const ProejctContainer = styled.div`
  display: flex;
  flex: 1;
  gap: 1.5rem;
  align-items: center;
  
  @media (max-width: 768px) {
    justify-content: flex-start;
    width: 100%;
    flex-wrap: wrap;
    gap: 1rem;
  }
  
  @media (max-width: 480px) {
    gap: 0.75rem;
  }
`;

// New styled components for enhanced dashboard
const WelcomeSection = styled.div`
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-radius: 1.5rem;
  padding: 2rem;
  margin: 1.5rem;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  max-width: 600px;
  
  @media (max-width: 768px) {
    margin: 1rem;
    padding: 1.5rem;
    border-radius: 1.25rem;
    max-width: 100%;
  }
  
  @media (max-width: 480px) {
    margin: 0.75rem;
    padding: 1.25rem;
    border-radius: 1rem;
  }
`;

const WelcomeContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 1rem;
    text-align: center;
  }
`;

const WelcomeText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

const GreetingTitle = styled.h1`
  font-size: 2rem;
  font-weight: 700;
  background: linear-gradient(135deg, #E36E00 0%, #FFAE00 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  letter-spacing: -0.5px;
  line-height: 1.2;
  margin: 0;
  
  @media (max-width: 768px) {
    font-size: 1.75rem;
  }
  
  @media (max-width: 480px) {
    font-size: 1.5rem;
  }
`;

const GreetingSubtitle = styled.p`
  font-size: 1.125rem;
  color: #6b7280;
  font-weight: 500;
  margin: 0;
  
  @media (max-width: 768px) {
    font-size: 1rem;
  }
  
  @media (max-width: 480px) {
    font-size: 0.875rem;
  }
`;

const WelcomeIcon = styled.div`
  font-size: 3rem;
  color: #E36E00;
  opacity: 0.8;
  
  @media (max-width: 768px) {
    font-size: 2.5rem;
  }
  
  @media (max-width: 480px) {
    font-size: 2rem;
  }
`;

const StatsSection = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1.5rem;
  margin: 0 1.5rem 1.5rem 1.5rem;
  
  @media (max-width: 768px) {
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 1rem;
    margin: 0 1rem 1rem 1rem;
  }
  
  @media (max-width: 480px) {
    grid-template-columns: 1fr;
    gap: 0.75rem;
    margin: 0 0.75rem 0.75rem 0.75rem;
  }
`;

const StatCard = styled.div`
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-radius: 1.25rem;
  padding: 1.5rem;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 1rem;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 25px 50px rgba(0, 0, 0, 0.15);
  }
  
  @media (max-width: 768px) {
    padding: 1.25rem;
    border-radius: 1rem;
  }
  
  @media (max-width: 480px) {
    padding: 1rem;
    gap: 0.75rem;
  }
`;

const StatIcon = styled.div`
  font-size: 2.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  border-radius: 1rem;
  background: rgba(255, 255, 255, 0.8);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  
  @media (max-width: 768px) {
    font-size: 2rem;
    width: 50px;
    height: 50px;
    border-radius: 0.75rem;
  }
  
  @media (max-width: 480px) {
    font-size: 1.75rem;
    width: 45px;
    height: 45px;
  }
`;

const StatContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  flex: 1;
`;

const StatNumber = styled.div`
  font-size: 2rem;
  font-weight: 700;
  color: #1f2937;
  line-height: 1;
  
  @media (max-width: 768px) {
    font-size: 1.75rem;
  }
  
  @media (max-width: 480px) {
    font-size: 1.5rem;
  }
`;

const StatLabel = styled.div`
  font-size: 0.875rem;
  color: #6b7280;
  font-weight: 500;
  
  @media (max-width: 480px) {
    font-size: 0.8rem;
  }
`;

const ProjectsSection = styled.div`
  margin: 0 1.5rem 1.5rem 1.5rem;
  
  @media (max-width: 768px) {
    margin: 0 1rem 1rem 1rem;
  }
  
  @media (max-width: 480px) {
    margin: 0 0.75rem 0.75rem 0.75rem;
  }
`;

const SC = {
  Container,
  Banner,
  LineImage,
  Greeting,
  GreetingTextDiv,
  GreetingText,
  HandImage,
  FormattedDate,
  WorkImage,
  CircleImage,
  TabDiv,
  Input,
  CardDiv,
  ViewText,
  SecondWrapper,
  Heading,
  Link,
  LinkWrapper,
  SecondWrapperChild,
  Noproject,
  InputContiner,
  SearchIcon,
  InputStyle,
  ResponsiveContainer,
  StyledSelect,
  ControlsWrapper,
  ProejctContainer,
  WelcomeSection,
  WelcomeContent,
  WelcomeText,
  GreetingTitle,
  GreetingSubtitle,
  WelcomeIcon,
  StatsSection,
  StatCard,
  StatIcon,
  StatContent,
  StatNumber,
  StatLabel,
  ProjectsSection,
};

export default SC;
